// *********************************
// CoolGames Builder JavaScript file
// *********************************
import { ComponentButton } from "../../framework/components/ComponentButton";
import { ComponentContainer } from "../../framework/components/ComponentContainer";
import { ComponentLabel } from "../../framework/components/ComponentLabel";
import { ComponentPicture } from "../../framework/components/ComponentPicture";
import { DialogBase } from "../../framework/dialogs/DialogBase";
import { tgfDictionary } from "../../framework/tgfDictionary";
import { tgfDialogs } from "../../framework/dialogs/tgfDialogs";
import { tgfGraphics } from "../../framework/tgfGraphics";
import { tgfSettings } from "../../framework/tgfSettings";
import { DialogSettings } from "../../settings/Settings";
import { SoundManager } from "../../settings/SoundManager";
import { AngryAnalytics } from "../Analytics/Analytics";
import { s_bg_placeholder, s_black_square, s_popup_darkblue_rect, s_popup_top, s_popup_bottom, s_btn_green } from "../AssetDefinitions/ImageDefinitions";
import { EventSystem } from "../Events/EventSystem";
import { Events } from "../Events/Events";
tgfSettings.dialogDefaults.FailedInviteDialog = {
    width: 800,
    height: 400,
    font: DialogSettings.textFont,
    smallFont: DialogSettings.textFontSmall,
    buttonFont: DialogSettings.buttonFont,
    includeBackground: false,
    components: [] // The additional components to add
};
export var FailedInviteDialog = function (properties) {
    "use strict";
    this.name = "FailedInviteDialog"; // The name of the dialog
    // Initialize properties
    this.initialize(tgfSettings.dialogDefaults.FailedInviteDialog);
    // Set user properties
    if (properties !== undefined) {
        this.setProperties(properties);
    }
    this.onDisconnect = this.close.bind(this, false);
    EventSystem.subscribe(Events.DISCONNECTED, this.onDisconnect);
};
// Inherit the base dialog
tgfDialogs.inherit(FailedInviteDialog, DialogBase);
FailedInviteDialog.prototype.doPrepare = function () {
    "use strict";
    AngryAnalytics.reportScreen("matilda", "error_popup");
    if (this.includeBackground) {
        this.lobbyBG = new ComponentPicture({
            image: s_bg_placeholder,
            xScale: 2,
            yScale: 2
        });
        this.addComponent(this.lobbyBG);
    }
    this.transparentBlack = new ComponentButton({
        x: tgfGraphics.areaWidth / 2,
        y: tgfGraphics.areaHeight / 2,
        xScale: Math.round(tgfGraphics.areaWidth / s_black_square.width) + 20,
        yScale: Math.round(tgfGraphics.areaHeight / s_black_square.height) + 20,
        alpha: 0.7,
        image: s_black_square
    });
    this.addComponent(this.transparentBlack);
    this.background = new ComponentPicture({
        image: s_popup_darkblue_rect,
        createFromSlices: true,
        sliceMarginsArray: [55, 55, 55, 55],
        width: this.width,
        height: this.height,
        x: -(this.width / 2),
        y: -(this.height / 2)
    });
    this.transparentBlack.addComponent(this.background);
    this.headerBackground = new ComponentPicture({
        image: s_popup_top,
        x: tgfGraphics.areaWidth / 2,
        y: -this.height / 2 + tgfGraphics.areaHeight / 2
    });
    this.addComponent(this.headerBackground);
    this.addComponent(new ComponentPicture({
        image: s_popup_bottom,
        x: tgfGraphics.areaWidth / 2,
        y: this.height / 2 - 20 + tgfGraphics.areaHeight / 2
    }));
    this.headerLabel = new ComponentLabel({
        text: tgfDictionary.getText("INVITE_FRIENDS_ERROR_HEADER"),
        font: this.font,
        y: 4
    });
    this.headerBackground.addComponent(this.headerLabel);
    this.centerLabel = new ComponentLabel({
        text: tgfDictionary.getText("INVITE_FRIENDS_ERROR_TEXT"),
        font: this.font,
        x: tgfGraphics.areaWidth / 2,
        y: tgfGraphics.areaHeight / 2 - this.height / 2 + 150,
        splitLines: true,
        width: this.width - 20,
    });
    this.addComponent(this.centerLabel);
    this.buttonContainer = new ComponentContainer({
        x: tgfGraphics.areaWidth / 2,
        y: tgfGraphics.areaHeight / 2 + this.height / 2 - 100
    });
    this.addComponent(this.buttonContainer);
    this.acceptButton = new ComponentButton({
        image: s_btn_green,
        text: tgfDictionary.getText("BTN_REWARD_POPUP"),
        fontUp: this.buttonFont,
        onClick: this.onAccept.bind(this),
    });
    this.buttonContainer.addComponent(this.acceptButton);
    // AngryAnalytics.reportScreen("opt_in");
};
FailedInviteDialog.prototype.onAccept = function () {
    SoundManager.playEffect(SoundManager.UI_STATE.SELECT, SoundManager.UICollection, 0, false);
    this.close();
};
FailedInviteDialog.prototype.close = function () {
    this.hide();
    this.free();
    EventSystem.unsubscribe(Events.DISCONNECTED, this.onDisconnect);
    if (this.onClose) {
        this.onClose();
    }
};
FailedInviteDialog.prototype.toggleInput = function (enable) {
    if (enable) {
        this.activate();
    }
    else {
        this.deactivate();
    }
};
